/* @flow */
import { fromJS } from 'immutable';
import { EntityType } from './types';

export const entityTypeListToOrderedMap = (list: $TODO) => {
  return fromJS(list)
    .toOrderedMap()
    .map(x => EntityType(x))
    .mapKeys((k, v) => v.get('guid'));
};



// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/utils.js